import React, { useCallback, useEffect, useState } from "react";
import { getSubscriptionStatus } from "../../api/subscriptionApi";
import {
  clearPricingRequirement,
  isPricingSelectionRequired,
} from "../../helper/pricingHandoff";
import PricingSubscriptionModal from "./PricingSubscriptionModal";

/**
 * Blocks the private app with the pricing modal when onboarding left a
 * requirePricingSelection flag in sessionStorage AND the account has no real
 * entitlement (owner ruling 2026-08-26, #413). An active trial or paid plan
 * reports `is_active`; the flag alone never paywalls. When entitlement cannot
 * be read the gate fails open: the backend still enforces paid access.
 */
export default function PricingSubscriptionGate({ children }) {
  const [required, setRequired] = useState(false);

  useEffect(() => {
    if (!isPricingSelectionRequired()) return undefined;
    let cancelled = false;
    getSubscriptionStatus().then((response) => {
      if (cancelled || response?.status !== 200) return;
      if (response.data?.is_active) {
        clearPricingRequirement();
        return;
      }
      setRequired(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const handleCompleted = useCallback(() => {
    setRequired(false);
  }, []);

  return (
    <>
      {children}
      <PricingSubscriptionModal
        open={required}
        onCompleted={handleCompleted}
      />
    </>
  );
}
